"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/store";
import { setToastDispatch, bindToastActions } from "@/utils/toastUtil";
import { showToast, hideToast } from "@/store/snackbar/toastSlice";

export default function ToastDispatchBridge() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    setToastDispatch(dispatch);
    bindToastActions(showToast, hideToast);
  }, [dispatch]);

  return null;
}
